// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","ProductReport":"eo_a bhi_a bhi_x bhi_j bhi_u bhi_bc bhi_qj bhi_vt"};